import { useCallback, useMemo } from "react";
import { Card } from "reactstrap";
import Content from "./Content";
import { usePreferences } from "../../Configuration/hooks/usePreferences";
import { usePreferenceMutation } from "../../Configuration/api/usePreferenceMutation";

function Notifications() {
    const notifications = usePreferences("notifications");
    const { mutateAsync: submit, isPending: submitting } = usePreferenceMutation("company", "notifications");

    const values = useMemo(() => ({ notifications }), [notifications]);

    const onFinish = useCallback(
        async (config, onSuccess) => {
            try {
                const response = await submit(config);
                onSuccess?.(response);
            } catch (error) {
                // error toast handled by usePreferenceMutation
            }
        },
        [submit]
    );

    return (
        <Card className="h-100">
            <Content
                values={values}
                submitting={submitting}
                submit={onFinish}
                page="mainCompany"
            />
        </Card>
    );
}
export default Notifications;
